import React, { useEffect } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import useRegistrationDataViewModel from "../viewmodel/RegistrationVM";
import useGsOneMainPageViewModel from "../viewmodel/GSMainPageVM";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";
import CChooseFile2 from "../../../basecomp/components/CChooseFile";

const inputStyle = {
  width: "100%",
  marginBottom: "1em",
};

function RegistrationDataView() {
  const {
    plantOptions,
    material,
    materialCheckResult,
    option1,
    option2,
    showAdditionalFields,
    additionalFieldName,
    handleSubmit,
    handleOption1Change,
    handleOption2Change,
    setMaterial,
    handleImageUploadObj,
    handleImageUploadAsset,
  } = useRegistrationDataViewModel();
  const { t } = useTranslation();

  const { asset_id } = useGsOneMainPageViewModel();
  const userTerminal = localStorage.getItem("terminal");
  useEffect(() => {
    if (asset_id !== "null") {
      sessionStorage.setItem(
        "logingsoneurl",
        `/warehouse/asset-info?asset_id=${asset_id}`
      );
    }
  }, []);

  return (
    <Grid item xs={10} sm={8} md={10} sx={{ margin: "1em 1em 0.5em 1em" }}>
      <Card sx={{ padding: "2em" }}>
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <TextField
              id="asset-id"
              label={t("asset_id")}
              value={asset_id}
              variant="outlined"
              disabled
              style={inputStyle}
            />
            <FormControl variant="outlined" style={inputStyle}>
              <InputLabel>{t("plant_name")}</InputLabel>
              <Select
                value={userTerminal || option1}
                onChange={handleOption1Change}
                label={t("plant_name")}
                disabled={!!userTerminal}
                //  label="Plant"
              >
                {plantOptions.map((plant) => (
                  <MenuItem key={plant.id} value={plant.id}>
                    {plant.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{t("select_plant")}</FormHelperText>
            </FormControl>
            <FormControl variant="outlined" style={inputStyle}>
              <InputLabel>{t("asset_type")}</InputLabel>
              <Select
                value={option2}
                onChange={handleOption2Change}
                label={t("asset_type")}
              >
                <MenuItem value="option1">{t("asset")}</MenuItem>
                <MenuItem value="option2">{t("spare_part")}</MenuItem>
              </Select>
              <FormHelperText> {t("select_asset")}</FormHelperText>
            </FormControl>
            {showAdditionalFields && option2 === "option2" && (
              <>
                <TextField
                  id="material-no"
                  label={additionalFieldName}
                  variant="outlined"
                  value={material}
                  onChange={(event) => setMaterial(event.target.value)}
                  style={inputStyle}
                />
                <p
                  style={{
                    color: materialCheckResult === null ? "red" : "green",
                    marginBottom: "1em",
                  }}
                >
                  {materialCheckResult === null
                    ? t("not_present")
                    : materialCheckResult.material_desc}
                </p>
              </>
            )}
            {showAdditionalFields && option2 === "option1" && (
              <>
                <TextField
                  id="fuel-asset-id"
                  label={t("equipment_id")}
                  variant="outlined"
                  style={inputStyle}
                />
                <TextField
                  id="fuel-asset-name"
                  label={t("equipment_type")}
                  variant="outlined"
                  style={inputStyle}
                />
              </>
            )}

            <CChooseFile2
              id="object-photo"
              label={t("obj_photo")}
              variant="outlined"
              required={true}
              onChange={handleImageUploadObj}
              style={inputStyle}
              accept="image/*"
              cHelperText=""
            />
            <div style={{ marginTop: "1em" }}></div>
            <CChooseFile2
              id="id-plate-photo"
              label={t("id_plate_photo")}
              variant="outlined"
              required={true}
              onChange={handleImageUploadAsset}
              style={inputStyle}
              accept="image/*"
              cHelperText=""
            />
            <div style={{ marginTop: "1em" }}></div>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={inputStyle}
              disabled={materialCheckResult === null}
            >
              {t("submit")}
            </Button>
          </form>
        </Grid>
      </Card>
    </Grid>
  );
}

export default RegistrationDataView;
